import React from "react";
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import LogoImage from "images/spurnest_logo_half.png";

const NavLinks = tw.div`flex flex-wrap gap-4 mb-6`;
const BackLink = tw(Link)`inline-flex items-center text-primary-500 font-semibold text-sm hover:text-primary-700 transition duration-300`;
const Banner = tw.div`bg-primary-500 text-gray-100 py-10 px-6 rounded-lg mb-10 flex flex-col sm:flex-row items-center justify-between gap-4`;
const BannerLogo = tw.img`w-12 h-12`;
const BannerText = tw.div`text-center sm:text-left`;
const BannerTitle = tw.h1`text-2xl sm:text-3xl font-black`;
const BannerSubtitle = tw.p`text-primary-100 mt-1 text-sm`;
const LastUpdated = tw.p`text-sm text-gray-500 mb-8`;

const Container = tw.div`relative max-w-3xl mx-auto px-4 sm:px-8 py-8 md:py-12`;
export const Section = tw.section`mb-8`;
export const SectionTitle = tw.h2`text-xl font-bold text-gray-900 mb-3`;
export const Paragraph = tw.p`text-base text-secondary-100 leading-relaxed mb-4`;
export const List = tw.ul`list-disc list-inside text-base text-secondary-100 leading-relaxed mb-4`;
export const ListItem = tw.li`mb-2`;

export default ({
  productName,
  productUrl,
  title,
  lastUpdated,
  children,
}) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <NavLinks>
          <BackLink to="/">&larr; Back to Home</BackLink>
          {productUrl && (
            <BackLink to={productUrl}>&larr; Back to {productName}</BackLink>
          )}
        </NavLinks>

        <Banner>
          <BannerLogo src={LogoImage} alt="Spurnest Techlabs" />
          <BannerText>
            <BannerTitle>{title}</BannerTitle>
            <BannerSubtitle>{productName} by Spurnest Techlabs</BannerSubtitle>
          </BannerText>
        </Banner>

        {lastUpdated && <LastUpdated>Last updated: {lastUpdated}</LastUpdated>}

        {children}
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
